import { ArtistDashboard } from 'NewVersion/components/Proposal/ArtistDashboard'
import 'NewVersion/styles/ProposalsStyles.scss'

/**
 * ArtistDashboardPage - Page wrapper for the Artist Dashboard
 */
const ArtistDashboardPage = () => {
  return (
    <section className="proposals page-wrapper">
      <ArtistDashboard />
    </section>
  )
}

export default ArtistDashboardPage
